__turbopack_context__.v({
  "className": "neueplak_d21d9837-module__YZlf4G__className",
  "variable": "neueplak_d21d9837-module__YZlf4G__variable",
});
